import { TaskInstance, TRemainingTasks } from '../types';

const initialRemainingTasks: TRemainingTasks = {
  document: [] as TaskInstance[],
  question: [] as TaskInstance[],
  section: [] as TaskInstance[],
  other: [] as TaskInstance[],
};

/*
 * Categorizes remaining internal and incomplete tasks into document, section, and question types.
 *
 * @param response - Array of TaskInstance objects to categorize
 * @returns TRemainingTasks object with tasks categorized by their entity type
 */
export function categorizeRemainingTasks(
  response?: TaskInstance[],
): TRemainingTasks {
  // Early return for empty input
  if (!response || response.length === 0) {
    return { ...initialRemainingTasks };
  }

  // Initialize result object
  const result: TRemainingTasks = {
    document: [],
    other: [],
    question: [],
    section: [],
  };

  // Single pass through the array for optimal performance
  for (const task of response) {
    // Skip non-internal or completed tasks

    const taskEntityType = task.task_entity?.type;

    if (taskEntityType) {
      switch (taskEntityType) {
        case 'document':
          result.document.push(task);
          break;
        case 'section':
          result.section.push(task);
          break;
        case 'question':
          result.question.push(task);
          break;
        default:
          result.other.push(task);
          break;
      }
    } else {
      // Special handling for tasks without a defined entity type
      // e.g., document_type_requested tasks which has to be categorized under document
      if (task.task_type === 'document_type_requested') {
        result.document.push(task);
      }
    }
  }

  return result;
}
